export const USER = {
  ADD: 'e29b38e9',
  EDIT: 'fcda8eab',
  LIST: '6c2e63c0',
  DELETE: '351e546e',
  GETBYID: '3171d828',
  DEACTIVATE: 'ea168848',
  ACTIVATE: '7c957a0c',
};

export const PERMISSIONS = {
  ADD: '0cd44e80',
  EDIT: '6f471ec2',
  LIST: '4701bf1b',
  DELETE: '861f640c',
  GETBYID: 'aa4ab78e',
  DEACTIVATE: 'a0b34717',
  ACTIVATE: '265ddfd9',
};

export const ROLES = {
  ADD: '77334634',
  EDIT: 'ab16bbc6',
  LIST: 'ab16bbc7',
  DELETE: '336415fe',
  GETBYID: 'ead6a667',
  DEACTIVATE: '2db21577',
  ACTIVATE: '5a745635',
};

export const VEHICLES = {
  ADD: '077027fa',
  EDIT: '85cf51a0',
  LIST: 'cf013eba',
  DELETE: 'bf9d2f1b',
  GETBYID: '2357a65f',
  DEACTIVATE: 'a77f8d3c',
  ACTIVATE: '94fec1b2',
};

export const DRIVER = {
  ADD: '61fa64f4',
  EDIT: '7440e1e6',
  LIST: 'cca82fb8',
  DELETE: '45304bde',
  GETBYID: 'e4a12d0b',
  DEACTIVATE: '283b09cf',
  ACTIVATE: 'fc7acc6d',
  CODRIVER: '01f9a1f5',
};

export const OFFICES = {
  ADD: '18a89f47',
  EDIT: '38ff140c',
  LIST: '4fb58e83',
  DELETE: '83e5db35',
  GETBYID: 'bba572b3',
  DEACTIVATE: 'f04af497',
  STATES: 'cd827f7e',
  ACTIVATE: 'd59481d7',
};

export const COMPANIES = {
  EDIT: 'dcd2daab',
  GETBYID: '52daf208',
};

export const ELD = {
  ADD: '535d7cca',
  EDIT: '526fa558',
  LIST: 'ceb5ae7f',
  DELETE: '993ad02b',
  GETBYID: '76be248d',
  DEACTIVATE: '3b93123c',
  ACTIVATE: 'f6468c58',
};

export const ASSETS = {
  ADD: '3ba6dbbe',
  EDIT: '10cab206',
  LIST: '371ea9ff',
  DELETE: '7d810b3b',
  GETBYID: '47152721',
  DEACTIVATE: '6692d5e2',
  ACTIVATE: '52972ccd',
};

export const UNITS = {
  LIST: '90b5bafe',
};

export const HOS = {
  HISTORY: 'e2a62567',
  LIVE: 'dfc1b20f',
  PROFILE: 'b3f3df82',
  HISTORYBYPARAM: 'c7930c50',
  GRAPH: '30c7db5e',
};
